import UserFlux from '@userflux/browser-js'
declare global {
    interface Window {
        ga4TagGeneric?: (tag: object) => void;
    }
}

export function ga4PackagesExtraGTM(packageName: string, ewInteractionAction: string, supplierName: string, addonName: string, count: number | null = null, enableGTMTracking: boolean)
{
    const extraFields = {
        'packageName': packageName,
        'ewInteractionAction': ewInteractionAction,
        'supplierName': supplierName,
        'addonName': addonName
    } as any;

    if (count != null) {
        extraFields['addonCount'] = count;
    }

    ga4Event('package_addon_selected', extraFields);
}

export function ga4Event(event: string, extraFields = {}, enableGTMTracking: boolean = false)
{   
    let obj = {
        'event': event,
        ...extraFields
    };

    obj = JSON.parse(JSON.stringify(obj));

    if (enableGTMTracking) {
        ga4Generic(obj);
    }
    else {
        console.log(obj);
    }    
}

export function ga4Generic(obj: {}) {
    const wnd = (window as any);

    if (!wnd) {
        return;
    }

    wnd.dataLayer = wnd.dataLayer || [];
    wnd.dataLayer.push(obj);
}

export function dashboardTrackingEnabled(): boolean {
    return !!(window as any)?.enableGTMTracking;
}

export function gtagEvent(eventName: string, extraFields = {}): boolean {
    if (typeof window.ga4TagGeneric === 'function') {
        let obj = {
            'event': eventName,
            ...extraFields
        };
        window.ga4TagGeneric(JSON.parse(JSON.stringify(obj)));

        UserFlux.track({
            event: eventName,
            properties: extraFields,
            enrichDeviceData: true,
            enrichLocationData: true,
            enrichPageProperties: true,
            enrichReferrerProperties: true,
            enrichUTMProperties: true,
            enrichPaidAdProperties: true,
            addToQueue: true
        });
        return true;
    }
    console.warn('ga4TagGeneric function is not defined on the page.');
    return false;
}
